"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("modules/auth");
const MembershipService_1 = __importDefault(require("modules/membership/MembershipService"));
const MembershipStore_1 = __importDefault(require("modules/membership/MembershipStore"));
const user_1 = require("modules/user");
const utils_1 = require("modules/utils");
const ua_parser_js_1 = require("ua-parser-js");
const types_1 = require("./types");
const constants_1 = require("../../ga/constants");
class BaseSchema {
    constructor() {
        var _a, _b, _c, _d;
        const userAgentParser = (0, ua_parser_js_1.UAParser)(navigator.userAgent);
        const browserInfo = userAgentParser.browser;
        this.platform = types_1.Platform.WEB;
        this.osVersion = (_a = browserInfo.version) !== null && _a !== void 0 ? _a : '';
        this.platformDetail = (_b = browserInfo.name) !== null && _b !== void 0 ? _b : '';
        this.appVersion = (_c = process.env.PROJECT_VERSION) !== null && _c !== void 0 ? _c : '';
        this.isLogged = true;
        this.membershipId = MembershipService_1.default.membershipId
            ? String(MembershipService_1.default.membershipId)
            : String(MembershipStore_1.default === null || MembershipStore_1.default === void 0 ? void 0 : MembershipStore_1.default.id);
        this.membershipSlug =
            MembershipService_1.default.slug || (0, utils_1.getSlug)() || types_1.ClubVersion.OLD_CLUB_ADMIN;
        this.userId = Number(user_1.UserStore === null || user_1.UserStore === void 0 ? void 0 : user_1.UserStore.marketplaceId) || 0;
        this.userRole = ((_d = auth_1.AuthService.roles) === null || _d === void 0 ? void 0 : _d[0]) || '';
        this.ucode = (MembershipStore_1.default === null || MembershipStore_1.default === void 0 ? void 0 : MembershipStore_1.default.code) || '';
        this.clubVersion = MembershipService_1.default.clubVersion;
        this.url = window.location.href;
        this.sessionId = constants_1.GOOGLE_TAG_MANAGER_ID || 'X';
        this.screenName = 'NOT_APP_EVENT';
    }
    prepare() {
        return {
            platform: this.platform,
            platformDetail: this.platformDetail,
            osVersion: this.osVersion,
            appVersion: this.appVersion,
            membershipId: this.membershipId,
            membershipSlug: this.membershipSlug,
            userId: Number(this.userId),
            userRole: this.userRole,
            ucode: this.ucode,
            isLogged: this.isLogged,
            clubVersion: this.clubVersion,
            url: this.url,
            sessionId: this.sessionId,
            screenName: this.screenName
        };
    }
}
exports.default = BaseSchema;
